import React from "react"
import types from "prop-types"
import Switch from "shared/Switch"
import ItemRow from "shared/ItemRow"
import * as API from "services/api"
import Tooltip from "shared/Tooltip"
import { errorToast } from "shared/toast"

const LOCKED_DESCRIPTION = "LOCKED after too many failed sign-in attempts."
const UNLOCKED_DESCRIPTION = "UNLOCKED"
const USER_UPDATE_ERROR_MESSAGE = "Unable to unlock account"

const UserLocked = ({ user, updateLocked }) => {
  const updateUserLocked = async (locked) => {
    const response = await API.updateUserLocked({ userId: user.id, locked })
    if (response.ok) {
      updateLocked(locked)
    } else {
      const errorsString = response.data.errors.join(", ")
      errorToast(`${USER_UPDATE_ERROR_MESSAGE}: ${errorsString}`)
    }
  }

  const descriptionClassName = user.locked ? "text-error" : "text-success"
  const statusDescription = user.locked ? LOCKED_DESCRIPTION : UNLOCKED_DESCRIPTION

  const ableToUnlock = user.identityUpdateableByCurrentIdentity
  const tooltipText = (!ableToUnlock && user.locked) ? "Cannot unlock account. Email support@performancehealth.app for assistance." : ""

  return (
    <ItemRow
      className="dark"
      itemRowHeaderContent={(
        <>
          <span className="font-bold">Locked Status</span>
          <Tooltip text={tooltipText}>
            <Switch
              checked={user.locked}
              disabled={!user.locked || !ableToUnlock}
              onChange={updateUserLocked}
            />
          </Tooltip>
        </>
      )}
      itemRowBody={(
        <p className={descriptionClassName}>Account is currently {statusDescription}</p>
      )}
    />
  )
}

UserLocked.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  user: types.object.isRequired,
  updateLocked: types.func.isRequired,
}

export default UserLocked
